import React from 'react';
import { SealCheck } from '@phosphor-icons/react';

/**
 * Reusable "Verified Pro" badge.
 * Sizes: sm (inline next to a name), md (card overlay), lg (profile hero).
 */
export default function VerifiedBadge({ size = 'sm', label = true, className = '' }) {
  const dims = {
    sm: { wrap: 'h-6 px-2 text-[10px] gap-1', icon: 12 },
    md: { wrap: 'h-7 px-3 text-xs gap-1.5', icon: 14 },
    lg: { wrap: 'h-9 px-4 text-sm gap-2', icon: 18 },
  }[size] || { wrap: 'h-6 px-2 text-[10px] gap-1', icon: 12 };

  return (
    <span
      className={`inline-flex items-center font-black uppercase tracking-wider bg-emerald-500 text-white border-2 border-black rounded-full ${dims.wrap} ${className}`}
      title="Licensed & insured — verified by ConstructHelp"
      data-testid="verified-pro-badge"
    >
      <SealCheck size={dims.icon} weight="fill" />
      {label && 'Verified Pro'}
    </span>
  );
}
